export function sourceMarketingFlagVisible(type) {
    return type === "Other";
}

export function sourceMarketingFlagForForm(value) {
    return value === true;
}

export function sourceMarketingFlagPayload(type, formData) {
    const {includeInMarketingCosts, ...sourceData} = formData ?? {};

    return type === "Other"
        ? {...sourceData, includeInMarketingCosts: includeInMarketingCosts === true}
        : sourceData;
}

export function sourceMarketingFlagReportValue(type, value) {
    if (type !== "Other" || typeof value !== "boolean") return null;
    return value;
}
